<div class="testimonials-wrapper">
  <!-- Left Side: Dark Blue Badge Box -->
  <div class="testimonials-header-box">
    <div class="header-badge">Testimonials</div>
    <h2>Listen to those who have been there !</h2>
  </div>

  <!-- Right Side: Scrolling Container -->
  <div class="testimonials-scroller-container">
    <div #testimonialContainer 
         class="testimonials-scroller"
         (mouseenter)="pauseScroll()" 
         (mouseleave)="resumeScroll()">
         
      <div *ngFor="let t of extendedTestimonials" class="testimonial-card"
           [style.background]="t.bgColor" 
           [style.border]="'2px solid ' + t.borderColor"
           [class.has-video]="!!t.videoUrl">
           
          <!-- Text Layout -->
          <ng-container *ngIf="!t.videoUrl">
            <!-- Large Quote -->
            <div class="quote-mark" [style.color]="t.quoteColor">"</div>
            
            <!-- Testimonial Text -->
            <div class="testimonial-text">
                {{t.text}}
            </div>
          </ng-container>

          <!-- Video Layout -->
          <ng-container *ngIf="t.videoUrl">
            <div class="video-container">
              <iframe [src]="getSafeUrl(t.videoUrl)" allow="autoplay; fullscreen" frameborder="0"></iframe>
              <a [href]="t.videoUrl" target="_blank" class="open-new-tab" title="Open in new tab">
                <i class="pi pi-external-link"></i>
              </a>
            </div>
          </ng-container>

          <!-- Footer -->
          <div class="testimonial-footer">
              <!-- Avatar & Name -->
              <div class="avatar-container">
                  <div class="avatar" 
                       [style.background]="t.avatarColor" 
                       [style.color]="t.avatarTextColor">
                      {{t.avatarText}}
                  </div>
                  <div class="user-info">
                      <span class="user-name">{{t.name}}</span>
                      <span class="user-subtext">{{t.subtext}}</span>
                  </div>
              </div>

              <!-- Badge -->
              <div class="rating-badge"
                   [style.background]="t.badgeBgColor"
                   [style.color]="t.badgeTextColor">
                  <span>{{t.badgeText}}</span>
              </div>
          </div>
      </div>
    </div>
  </div>
</div>
